import { InputField } from '../../Input'
import { useSelectContext } from '../Select.hooks'

import { SELECT_DROPDOWN_LIST_SEARCH_INPUT_HEIGHT } from './SelectDropdownListSearchInput.constants'

import * as styles from './SelectDropdownListSearchInput.module.css'

import SearchIcon from '../../../icons/search.svg'

function SelectDropdownListSearchInput({
  height = SELECT_DROPDOWN_LIST_SEARCH_INPUT_HEIGHT,
  ...restProps
}) {
  const { handleChangeSearch, handleClearSearch, searchValue } =
    useSelectContext()

  return (
    <InputField
      {...restProps}
      autoFocus
      afterIconProps={{ Icon: SearchIcon }}
      height={height}
      value={searchValue}
      wrapperClassName={styles.search}
      onChange={handleChangeSearch}
      onClear={handleClearSearch}
    />
  )
}

export default SelectDropdownListSearchInput
